"use client";
import { useState, useRef, useCallback, useEffect } from "react";

const DEFAULT_ROOT_MARGIN = "50px 0px 0px 0px";
const DEFAULT_MIN_HEIGHT = "50px";

export const useInfiniteScrollIntersectionObserverBased = (
  shouldFetch,
  initPageNumber = 0,
  options = {},
) => {
  const [page, setPage] = useState(initPageNumber);
  const loadMoreRef = useRef(null);

  const handleObserver = useCallback(
    (entries) => {
      const [target] = entries;
      const shouldUpdatePage = target.isIntersecting && shouldFetch;
      if (shouldUpdatePage) {
        setPage((page) => page + 1);
      }
    },
    [shouldFetch],
  );

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: DEFAULT_ROOT_MARGIN,
      threshold: 0,
      ...options,
    };

    const observer = new IntersectionObserver(handleObserver, observerOptions);

    if (loadMoreRef.current) {
      loadMoreRef.current.style.minHeight = DEFAULT_MIN_HEIGHT;
      observer.observe(loadMoreRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [handleObserver]);

  return [loadMoreRef, page, setPage];
};
